<template>
  <div class="payment-box">
    <div class="transaction-msg fail">
      <span></span>
      Your payment has failed. Please try again, or choose another payment option.
    </div>
  </div>
</template>
<script>
import api from './api';
import moment from 'moment';
import mainNav from './mainNav';
import Cookies from 'js-cookie';
export default {
  mixins: [mainNav],
  data: ()=>({
    tab: 'payment',
  }),
}
</script>
